import { useEffect } from 'react';
import { useAppDispatch, useSelector } from 'App/components/hooks';
import { fetchParagonTokens } from 'Store/reducers/ExternalIntegrationReducer';

const useParagonToken = () => {
	const dispatch = useAppDispatch();
	const tokens = useSelector(state => state.ExternalIntegration.tokens);

	useEffect(() => {
		dispatch(fetchParagonTokens());
	}, [dispatch]);

	return { tokens };
};

export default useParagonToken;
